function navigateAfterInteraction(callback: () => void) {
    callback();
}

export default navigateAfterInteraction;
